import * as React from 'react';
import { FactLink } from 'app/area/case/components/fact-box/fact-link';
import { BadgeList } from 'ui/badge-list';
import { MdCheckBox } from 'react-icons/md';
import { FactItemProps } from 'app/area/case/components/fact-box/types';
import { ComponentProps } from 'ui/common';
import { isCaseViewModalOpen } from 'app/components/helpers';

interface FactItemChecklistProps extends ComponentProps, FactItemProps {
  numberOfChecklistItems: number;
  visibleForValues: string;
  checklistEvaluations: {
    key: number;
    value: number;
    tooltip: string;
    backgroundColor: string;
  }[];
}

export const ChecklistFactItem = (props: FactItemChecklistProps) => {
  const { tooltip, title, checklistEvaluations, numberOfChecklistItems, url, visibleForValues, linkDomain, portalTarget } = props;
  const icon = <MdCheckBox />;
  const splittedVisibleForValues = !!visibleForValues && String(visibleForValues)
    ?.split(',')
    ?.map(e => Number(e));
  const filteredChecklistEvaluations = !!splittedVisibleForValues?.length &&
    checklistEvaluations?.filter(r => splittedVisibleForValues.indexOf(r.key) > -1) || [];
  const totalChecklistItems = [
    {
      value: numberOfChecklistItems,
      tooltip: tooltip
    }
  ];
  const resultingItems = [
    ...totalChecklistItems,
    ...filteredChecklistEvaluations
  ];

  if (!numberOfChecklistItems) {
    return null;
  }
  return <FactLink id={props.componentId} classNames="fact-item" section={linkDomain} url={url} skipNavigation={isCaseViewModalOpen()}>
    <BadgeList
      icon={icon}
      title={title}
      valueItems={resultingItems}
      useNestedIndicator={true}
      portalTarget={portalTarget}
    />
  </FactLink>;
};
